import { RECEIPT_STATUS } from "./types";

export enum ClientType {
  B2B_APP = "B2B_APP",
}

export enum OrderType {
  HAILING_REQUEST = "HAILING_REQUEST",
}

export interface IReceiptPlaceInfo {
  displayName: string;
  formattedAddress: string;
}

export interface IReceiptTripItinerary {
  lat: number;
  lng: number;
  placeId: string;
  index: number;
  i18n: {
    en?: IReceiptPlaceInfo;
    zhHK?: IReceiptPlaceInfo;
  };
}

export interface IPaymentInformation {
  cardNumber: string;
  paymentMethod?: string;
}

export interface IReceiptDriverVehicle {
  model: string;
  make: string;
  iconUrl?: string;
}

export interface IHeartBeat {
  heading: number | null | string | undefined;
  lat: number;
  lng: number;
  speed: number | null | string | undefined;
}
export interface IReceiptDriver {
  nameZh: string;
  name: string;
  phoneNumber: string;
  licensePlate: string;
  heartBeat?: IHeartBeat;
  vehicle: IReceiptDriverVehicle;
  shape?: string;

  // QR Payment specific fields
  vehicleModel?: string;
  vehicleMake?: string;
  driverName?: string;
  driverId?: string;

  // MOBILE_PAYMENT specific field — masked, "***" + last 4 digits
  driverPhone?: string;
}

export interface IOrganizationInfo {
  name?: string;
  settings?: {
    webHailingPage?: {
      isShowSupportContact?: boolean;
      supportContactPhoneNumber?: string;
    }
  }
}
export interface IUser {
  phoneNumber: string;
}

// MOBILE_PAYMENT specific — GET /v2/public/hailing/:txId's MobilePaymentReceiptDto shape.
// Distinct field names from QR's paymentInformation/amount (tap has no `amount`, and its
// `paymentInfo` carries a full masked PAN + the stored payment method, not just a 4-digit suffix).
export interface ITapPaymentInfo {
  maskedCardNumber: string;
  cardType: string;
}

export interface Receipt {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: RECEIPT_STATUS;
  time?: string;
  tripItinerary: IReceiptTripItinerary[];
  paymentInformation: IPaymentInformation;
  driver?: IReceiptDriver;
  total: number;
  amount?: number;
  dashFee?: number;
  cancellationFee?: number;
  eta: number;
  encodedPolyline: string;
  driverRouteEncodedPolyline: string;
  user: IUser;
  type?: "QR_PAYMENT" | "MOBILE_PAYMENT";
  clientType?: string;
  organization?: IOrganizationInfo;
  supportContactPhoneNumber?: string;

  // MOBILE_PAYMENT specific fields
  fare?: number | null;
  paidAt?: string | null;
  paymentInfo?: ITapPaymentInfo | null;
  url?: string;
}